import { z } from "zod";

// add-api-evidence-dossier, "Admin UI": a finding of the audit that compares a service's
// reference with its latest approved dossier (spec requirement 10). It lives apart from
// `api-evidence.ts` because the administrator's operation detail (`api-reference.ts`) carries
// it too, and that module is imported by `api-evidence.ts`: one direction only.

export const findingViewSchema = z.object({
  // A plain string: a kind the page does not know is shown raw, not refused.
  kind: z.string(),
  operation_id: z.string().nullable(),
  subject: z.string().nullable(),
  detail: z.record(z.string(), z.unknown()),
});
export type FindingView = z.infer<typeof findingViewSchema>;
